import { Box, Grid, Paper, Typography } from '@mui/material';

import React from 'react';
import {
  AppFormikSelect,
  AppFormikTextField,
} from 'shared/components/AppComponents';

const PaperFormDetails: React.FC<PaperFormDetailsProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { purpose } = props;
  return (
    <Box className="paper-form-content">
      <Paper variant="outlined">
        <Typography variant="h6">Datasets Details</Typography>
        <Box className="paper-form-input-content">
          <Grid spacing={4} container className="paper-form-label-input-grid">
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="datasetName"
                placeholder="Enter dataset name"
                outerLabel
                label="Dataset Name*"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="owningTeam"
                placeholder="Enter owning team"
                outerLabel
                label="Owning Team*"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="contactperson"
                placeholder="Enter contact person"
                outerLabel
                label="Contact Person*"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelect
                name="lifecyclestage"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="solicitor-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select Lifecycle Stage"
                notEmphasized
                notSelectablePlaceholder
                label="Select Lifecycle Stage"
                items={['Training', 'Testing', 'Validation', 'Inference']}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelect
                name="sourcetype"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="solicitor-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select Source Type"
                notEmphasized
                notSelectablePlaceholder
                label="Source Type*"
                items={['Internal', 'Third-Party', 'Synthetic', 'Public']}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelect
                name="risktier"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="solicitor-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select Risk"
                notEmphasized
                notSelectablePlaceholder
                label="Risk Tier*"
                items={['Low', 'Moderate', 'High', 'Critical']}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelect
                name="w3ccredentials"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="solicitor-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select Watermarking Technique"
                notEmphasized
                notSelectablePlaceholder
                label="Watermarking Technique*"
                items={[
                  'C2PA',
                  'Project Origin',
                  'Content Authenticity Initiative',
                  'W3C Verifiable Credentials',
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextField
                name="purposeofuse"
                placeholder="Describe the purpose of use"
                outerLabel
                label="Purpose of Use *"
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default PaperFormDetails;
